import { RuleObject } from 'antd/lib/form';
import i18n from '~/i18n';

export type Validator = RuleObject['validator'];

// Custom validator function to allow only hyphen as a special character
export const validatePassportNumber: (v?: any) => Validator | any = (v) => (_: any, value: any) => {
  if (v) {
    return Promise.resolve();
  }

  // Passport number validation regex pattern
  const passportNumberPattern = /^[A-Z\d-]*$/;

  const characterAtBeginning = value && value[0];
  const characterAtEnd = value && value[value.length - 1];
  const isInvalidPlaceForHyphen = characterAtBeginning === '-' || characterAtEnd === '-';

  if (!value) {
    return Promise.reject(new Error(i18n.t('Please enter your passport number.')));
  }
  if (!passportNumberPattern.test(value)) {
    return Promise.reject(new Error(i18n.t('Passport number should contain letters, numbers, and hyphens only.')));
  }
  if (value.length < 6 || value.length > 18) {
    return Promise.reject(new Error(i18n.t('Passport number should be between 6 and 18 characters.')));
  }
  if (isInvalidPlaceForHyphen) {
    return Promise.reject(new Error(i18n.t('Invalid passport format.')));
  }
  return Promise.resolve();
};
